<template>
  <div class="relative w-full">
    <div>
      <Listbox
        as="div"
        class="relative w-full"
        v-model="selected"
        v-slot="{ open }"
        :name="name"
        :class="[hasError ? 'border-error' : 'border-neutral-20', inputClasses]"
      >
        <ListboxButton
          class="input-default-3 flex items-center justify-between"
          :class="open ? 'border-primary-light' : 'border-neutral-20'"
        >
          <div class="flex items-center">
            <slot name="selected" :selected="selectedOption">
              <span class="text-black">
                {{ selectedOption ? selectedOption.name : $t(placeholder) }}
              </span>
            </slot>
          </div>

          <img
            src="@/assets/images/base/icons/angle-down.svg"
            class="transform"
            :class="open ? 'rotate-180' : 'rotate-0'"
            height="6"
            width="14"
            loading="lazy"
            alt=""
          />
        </ListboxButton>

        <transition
          leave-active-class="transition ease-in duration-100"
          leave-from-class="opacity-100"
          leave-to-class="opacity-0"
        >
          <ListboxOptions
            class="pointer-events-auto absolute z-[100] mt-2 max-h-96 w-full overflow-auto rounded-2xl border border-gray bg-white py-3 opacity-100 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
          >
            <ListboxOption
              as="template"
              v-for="option in options"
              :value="option.value"
              :key="option.value"
            >
              <li
                class="transition-ease-in-out relative flex cursor-pointer items-center px-4 py-1 text-sm hover:bg-[#F5F7FA] md:text-base"
              >
                <div class="flex items-center">
                  <slot name="option" v-bind="option">
                    {{ option.name }}
                  </slot>
                </div>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </transition>
      </Listbox>
    </div>
    <label
      class="label-default absolute z-10 whitespace-nowrap pl-[18px] font-light uppercase text-[#666666]"
      v-if="label"
    >
      {{ label }}
      <span class="text-[#eb5757]" v-if="isRequired">*</span>
    </label>

    <ErrorMessage v-if="hasError" class="mt-1">
      {{ $t(errorMsg) }}
    </ErrorMessage>

    <slot name="errors"></slot>
  </div>
</template>

<script>
import ErrorMessage from "@/components/Core/ErrorMessage.vue";
import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from "@headlessui/vue";

export default {
  name: "BaseSelect",
  components: {
    Listbox,
    ListboxButton,
    ListboxOption,
    ListboxOptions,
    ErrorMessage,
  },
  emits: ["selected"],
  props: {
    initSelected: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: "",
    },
    errors: {
      type: Object,
      default: null,
    },
    anyDirty: {
      type: Boolean,
      default: true,
    },
    label: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: "action.choose",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    inputClasses: {
      type: String,
      default: "",
    },
  },
  computed: {
    selectedOption() {
      return this.options.find((option) => option.value === this.initSelected);
    },
    selected: {
      get() {
        return this.initSelected;
      },
      set(newSelected) {
        this.$emit("selected", newSelected);
      },
    },
    hasError() {
      return this.anyDirty && this.errors && this.errors?.[this.name];
    },
    errorMsg() {
      return this.errors[this.name] instanceof Array
        ? this.errors[this.name][0]
        : this.errors[this.name];
    },
  },
};
</script>
